import { useMemo } from 'react';
import { useData } from '../contexts/DataContext';

export const useTree = () => {
  const { sites, selectedSites, onSelectSite, loading, error } = useData();

  const treeData = useMemo(() => {
    console.log('Original sites data:', sites); // Log the original sites data

    const mappedTreeData = sites.map((station) => {
      console.log('Station data:', station); // Log each station's data
      
      const measurementsString = station.TypeofMeasurements;
      const measurements = measurementsString 
        ? measurementsString.split(',').map((type) => type.trim()) 
        : [];
      console.log('Parsed measurements:', measurements); // Log the parsed measurements
      
      return {
        key: station.id || `station-${station.name}`,
        title: `${station.name || 'Unnamed Station'} (${station.id || 'No ID'})`,
        children: measurements.map((measurement) => ({
          key: `${station.id || `station-${station.name}`}-${measurement}`,
          title: measurement,
        })),
      };
    });

    console.log('Mapped tree data:', mappedTreeData); // Log the mapped tree data
    return mappedTreeData;
  }, [sites]);

  return {
    treeData,
    selectedSites,
    onSelectSite,
    loading,
    error,
  };
};
